import { colors } from "assets/constants";
import { atom } from "recoil";

const authAtom = atom({
  key: "@auth_atom",
  default: <AuthDataT>{ company: { color: colors.theme } },
});

export default authAtom;
